import { useRef, useState } from 'react'
import { SActionBtn, SBack, SLowcodeList, STableActions } from 'shj-components'
import config from './config'
import { useNavigate } from 'react-router-dom'
import { getVendorInfoList } from '@/services/workerManagement'
import { authDict } from 'shj-utils'
import KeepAlive from 'react-activation'

export default function ListPage() {
  const listRef = useRef<any>();
  const history = useNavigate()
  const [platformTypeMap, setPlatformTypeMap] = useState<Record<string, string>>({});

  const fetchList = (values: { current: number; pageSize: number; query: Record<string, any> }) => {
    return new Promise(async (resolve, reject) => {
      try {
        const { current, pageSize, query } = values;
        getVendorInfoList(current, pageSize, query).then(data => resolve(data))
      } catch (e) {
        reject({ success: false });
      }
    });
  };

  const onAdd = () => {
    history('/config/serviceConfig/workerManagement/add');
  }

  const onEdit = (record) => {
    history(`/config/serviceConfig/workerManagement/edit/${record.id}`);
  }
  const onDetail = (record) => {
    history(`/config/serviceConfig/workerManagement/detail/${record.id}`);
  }
  const extension = {
    request: { fetchList },
    events: { onAdd },
    customRender: {
      vendorCodeRender(text: any, record: any) {
        return authDict['workerManagementViewDetail'] ? (
          <div
            onClick={() => onDetail(record)}
            style={{ color: '#1677ff', cursor: 'pointer' }}
          >
            {text}
          </div>
        ) : (
          <div>{text}</div>
        )
      },
      platformTypesRender(types: string) {
        if (types) {
          let typesList = JSON.parse(types)
          return typesList.map((type) => platformTypeMap[type]).join(';');
        } else {
          return ''
        }
      },
      actionTool(text: any, record: any) {
        return (
          <div>
            <STableActions>
              <SActionBtn onClick={() => onEdit(record)} auth={"workerManagementEdit"}>
                编辑
              </SActionBtn>
            </STableActions>
          </div>
        );
      },
    },
  };

  return <>
    <>
      <SBack title="承包商管理" />
      <SLowcodeList config={config} ref={listRef} {...extension} searchMode="group" rowKey={'id'} />
    </>
  </>;
}
